<div class="h-screen flex items-center justify-center px-4 relative bg-cover bg-center bg-no-repeat" 
  style="background-image: url('/assets/images/plotsbg.jpg');">
    <!-- Overlay per garantir llegibilitat -->
    <div class="absolute inset-0 bg-gray-900/50 backdrop-blur-sm"></div>
    
    <!-- Contingut centrat -->
    <div class="relative z-10">
        <activation-form></activation-form>
    </div>
</div>